<template>
<section class="section-padding bg-white">
                <div class="row justify-content-center">
                    <div class="col-lg-6 col-12 col-md-6">
                        <h1 class="section-title-center text-center">Mentions légales</h1>
                        <div class="mt-2 mb-2"><p style="text-align:center">Consulter les mentions légales OUICSPORT</p></div>
                    </div>
            
                    <div class="col-12">
                        <p class="CGU-text"><strong>Propriétaire du site</strong><br>
                            OUICSPORT - SARL au capital de 10000,00 €<br>
                            Siège social : 56 rue Fontaine du Gué - 95170 Deuil-la-Barre<br>
                            SIREN :&nbsp;852 096 536 RCS Pontoise<br>
                            contact@ouicsport.fr<br>
                            Directeur de la publication : Sylvain Laskri en tant que Gérant</p>

                            <p class="CGU-text">&nbsp;</p>

                            <p class="CGU-text"><strong>Conception et réalisation du site</strong><br>
                            SUBWEB SARL au capital de 6 500,00 €<br>
                            Siège social : 26 avenue René Duguay-Trouin – 78960 Voisins-le-Bretonneux<br>
                            RCS Versailles 808 462 485 – SIRET 80846248500026<br>
                            Contact : contact@subweb.pro</p>

                            <p class="CGU-text">&nbsp;</p>

                            <p class="CGU-text"><strong>Hébergement du site</strong><br>
                            OVH SAS<br>
                            2 bis Rue Kellermann<br>
                            59100 Roubaix&nbsp;<br>
                            RCS Lille 537 407 926</p>
                    </div>
                </div>
        </section>
</template>


<script>
export default {
  name: 'mentions-legales'
}
</script>

<style>
@media (min-width: 992px) {
    .section-padding {
        padding-top: 100px;
        padding-bottom: 100px;
    }
}

.section-padding {
    padding-top: 70px;
    padding-bottom: 70px;
    padding-left:70px;
    padding-right:70px;
}
.bg-white {
    background-color: #fff;
}

.text-center {
    text-align: center !important;
}

.mb-2, .my-2 {
    margin-bottom: .5rem !important;
}
.mt-2, .my-2 {
    margin-top: .5rem !important;
}
.mt-5, .my-5 {
    margin-top: 3rem !important;
}

.section-title-center {
    font-family: inherit;
        font-size: 1rem;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    font-size: 40px;
    line-height: 1.1;
}

@media (min-width: 768px) {
    .CGU-text {
        font-size: 16px;
        line-height: 24px;
    }
}

@media (min-width: 320px) {
    .CGU-text {
        font-size: 14px;
        line-height: 22px;
    }
}
.CGU-text {
    color: #929292;
    font-weight: 400;
    margin-bottom: 0;
}

/* ==================== NATIVE APP STYLES ==================== */
body.is-native .section-padding {
  padding: calc(env(safe-area-inset-top) + 16px) 18px calc(24px + env(safe-area-inset-bottom)) 18px !important;
}

body.is-native .section-title-center {
  font-size: 26px !important;
  line-height: 1.25 !important;
  text-align: center !important;
  margin-bottom: 8px;
}

body.is-native .CGU-text {
  font-size: 15px !important;
  line-height: 1.6 !important;
  color: #374151 !important;
  margin-bottom: 10px !important;
}

body.is-native .CGU-text strong {
  color: #111827;
  font-size: 16px;
}

body.is-native .row {
  margin: 0;
}

body.is-native .col-12,
body.is-native .col-lg-6,
body.is-native .col-md-6 {
  width: 100%;
  max-width: 100%;
  padding: 0;
  flex: 0 0 100%;
}
</style>
